import vizier from '../config/vizier.json'

export function getVizierByID(id) {
    const viz = vizier.find(viz => viz.id === id)
    return viz ? viz.image : 'unknown.png'
}